import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CandidateGridInfo, SortParameters, CandidateStatusCount } from 'src/app/core/api.gen';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImmigrationService {

  country:BehaviorSubject<number> = new BehaviorSubject<number>(null);
  businessTraveller:BehaviorSubject<number> = new BehaviorSubject<number>(null);
  apiUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  GetVisaByType(sortParameters: SortParameters, type?: string): Observable<CandidateGridInfo> {
    return this.http.post<CandidateGridInfo>(`${this.apiUrl}/api/Candidate/GetCandidates`, sortParameters);
  }

  GetVisaStatusByType(processtype: string): Observable<CandidateStatusCount[]> {
    return this.http.get<CandidateStatusCount[]>(`
    ${this.apiUrl}/api/Candidate/GetCandidateStatusCount?processtype=${encodeURIComponent(processtype)}`);
  }

  GetCandidateVisaType(candidateId: number): Observable<string> {
    return of('visa-pre-approval');
  }
}
export interface StepTypeImmigration {
  label: string;
  role: string;
  hideSaveAndSubmit:boolean;
  enableSaveAndSubmit:boolean;
  teamInfoprop:string,
  showComment:boolean
}
